// the build version taken from package.json
declare var BUILD_VERSION: string;
const SMARTGFX_VERSION = BUILD_VERSION;

declare var DEV_SERVER_PORT: string;

export { SMARTGFX_VERSION, DEV_SERVER_PORT };
